import React, { useState } from 'react';
import { AuthModal } from '../auth/AuthModal';
import { Navigation } from './Navigation';
import { Hero } from './Hero';
import { Features } from './Features';
import { HowItWorks } from './HowItWorks';
import { InterfaceMockups } from './InterfaceMockups';
import { Testimonials } from './Testimonials';
import { Benefits } from './Benefits';
import { Collaboration } from './Collaboration';
import { PricingSection } from './PricingSection';
import { MoonshotSection } from './MoonshotSection';
import { AnimatedBackground } from './AnimatedBackground';
import { CursorEffect } from './effects/CursorEffect';

// Import custom effects CSS
import './effects/LandingEffects.css';

export function LandingPage() {
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [authMode, setAuthMode] = useState<'login' | 'signup'>('login');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleAuthClick = (mode: 'login' | 'signup') => {
    setAuthMode(mode);
    setIsAuthModalOpen(true);
    setIsMobileMenuOpen(false);
  };

  return (
    <div className="relative min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
      {/* Fixed background that covers the entire viewport */}
      <div className="fixed inset-0">
        <AnimatedBackground />
      </div>

      {/* Cursor following effect */}
      <CursorEffect />

      {/* Scrollable content */}
      <div className="relative overflow-hidden">
        <Navigation
          isMobileMenuOpen={isMobileMenuOpen}
          setIsMobileMenuOpen={setIsMobileMenuOpen}
          onAuthClick={handleAuthClick}
        />
        <Hero onAuthClick={handleAuthClick} />
        <InterfaceMockups />
        <HowItWorks />
        <Features />
        <Collaboration />
        <Testimonials />
        <Benefits />
        <PricingSection onSignUp={() => handleAuthClick('signup')} />
        <MoonshotSection onSignUp={() => handleAuthClick('signup')} />
      </div>

      <AuthModal
        isOpen={isAuthModalOpen}
        mode={authMode}
        onClose={() => setIsAuthModalOpen(false)}
        onModeChange={setAuthMode}
      />
    </div>
  );
}
